<template>
    <el-dialog
            :close-on-click-modal="false"
            :before-close="resetForm"
            width="600px"
            :visible.sync="visible">

        <div slot="title">
            <z-title title="角色权限"></z-title>
        </div>
        <div>

        </div>
        <el-form :model="dataForm" :rules="rules" ref="ruleForm" class="rulefrom"  label-width="100px">
            <el-form-item label="菜 单"  prop="menuData">
              <div class="menulist" >
                  <el-tree
                          :data="data"
                          ref="tree"
                          show-checkbox
                          node-key="id"
                          @check-change="checkChange"
                          :props="defaultProps">
                  </el-tree>
              </div>
            </el-form-item>

                <!--<div class="flex-n fac">-->
                    <!--<el-form-item  prop="preBeginTime" label="预定时间段"  :show-message="false">-->
                    <!--<el-time-select-->
                            <!--placeholder="起始时间"-->
                            <!--v-model="dataForm.preBeginTime"-->
                            <!--class="mr-10 w-180"-->
                            <!--:picker-options="{start: '00:00',step: '00:30', end: '24:00',maxTime: dataForm.preEndTime}">-->
                    <!--</el-time-select>-->
                    <!--</el-form-item>-->
                    <!--<el-form-item label-width="0" label="" prop="preEndTime"  :show-message="false">-->

                    <!--<el-time-select-->
                            <!--placeholder="终止时间"-->
                            <!--v-model="dataForm.preEndTime"-->
                            <!--class="mr-10 w-180"-->
                            <!--:picker-options="{start: '00:00',step: '00:30', end: '24:00',minTime: dataForm.preBeginTime}">-->
                    <!--</el-time-select>-->
                    <!--</el-form-item>-->
                <!--</div>-->
            <!--</el-form-item>-->
            <el-form-item label="权 限"  prop="jurisdiction">
                <el-checkbox-group v-model="dataForm.jurisdiction" >
                    <el-checkbox v-for="(item,index) in jurisdictionList" :label="item.code" :key="item.code">{{item.label}}</el-checkbox>
                </el-checkbox-group>
            </el-form-item>

            <el-form-item class="mt-10 flex-n fje">
                <el-button type="primary" @click="submitForm('ruleForm')">保 存</el-button>
                <el-button @click="resetForm">取 消</el-button>
            </el-form-item>
        </el-form>
    </el-dialog>

</template>

<script>
    import ZTitle from "../../../components/ZTitle";

    export default {
        components: {ZTitle},
        name: "edit-jurisdiction",
        props:{
            id:String,
            visible:Boolean
        },
        data(){
            return{
                data:[],
                defaultProps: {
                    children: 'children',
                    label: 'menuName'
                },
                dataForm:{
                    menuData:[],
                    jurisdiction:[],
                },
                jurisdictionList:[
                    {
                        label:'显示预计收入',
                        code:'isDisplayPrein'
                    },
                    {
                        label:'可以编辑他人内容',
                        code:'isEditOther'
                    },
                    {
                        label:'可以看到他人电话',
                        code:'isSeeOther'
                    },
                ],
                rules: {
                },
            }
        },
        watch:{
            visible(newval,oldval){
                if(newval){
                    this.getData();
                }
            }
        },
        methods:{
            getData(){
                this.$axios.post("storeAuth/findByRoleIdStoreId",{
                    "roleId": this.id,
                    "storeId": this.$root.getStorage('storeId')
                }).then(res=>{
                    console.log(res.data)
                    if(res.data.auth){
                        var auth=res.data.auth;
                        var jurisdiction=[];
                        if(auth.isEditOther=='1'){
                            jurisdiction.push('isEditOther');
                        }
                        if(auth.isDisplayPrein=='1'){
                            jurisdiction.push('isDisplayPrein');
                        }
                        if(auth.isSeeOther=='1'){
                            jurisdiction.push('isSeeOther');
                        }
                        this.$set(this.dataForm,'jurisdiction',jurisdiction);
                    }
                    var menu=[],menuData=[];
                    for(var i in res.data.menu){
                        if(res.data.menu[i].menu_id!='1'){
                            menu.push(res.data.menu[i].menu_id);
                            menuData.push({
                                "menuId": res.data.menu[i].menu_id
                            })
                        }
                    }

                    this.$set(this.dataForm,'menuData',menuData)

                    this.getJurisdiction(menu);
                }).catch(err=>{
                    this.$message.error(err.msg)
                })
            },
            //获取权限列表
            getJurisdiction(selectmenu){
                this.$axios.get('/menu/menuRecurrenceAll/1/1').then(res=>{
                    console.log(res.data.children,selectmenu)
                    this.data=res.data.children||[];
                    var shouldChecked=[];
                    for(var i=0;i<res.data.children.length;i++){
                        var children=res.data.children[i].children;
                        if(children.length>0){
                            for(var j=0;j<children.length;j++){
                                if(selectmenu.indexOf(children[j].id)>-1){
                                    shouldChecked.push(children[j].id);
                                }
                            }
                        }else{
                            if(selectmenu.indexOf(res.data.children[i].id)>-1){
                                shouldChecked.push(res.data.children[i].id);
                            }
                        }
                    }
                    this.$refs.tree.setCheckedKeys(shouldChecked);

                }).catch(err=>{
                    this.$message.error(err.msg)
                })
            },
            //目录变化
            checkChange(data){
                console.log(data)
                console.log(this.$refs.tree.getCheckedKeys().concat(this.$refs.tree.getHalfCheckedKeys()))
                var selectmenu=this.$refs.tree.getCheckedKeys().concat(this.$refs.tree.getHalfCheckedKeys());
                var menuData=[];
                for(var i in selectmenu){
                    menuData.push({
                        "menuId": selectmenu[i]
                    })
                }
                this.$set(this.dataForm,'menuData',menuData)
            },
            //验证表单
            submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.submit();
                    } else {
                        this.$message.error('表单填写有误');
                        return false;
                    }
                });
            },
            submit(){
                var dataForm=this.dataForm;
                dataForm.menuData.push({menuId:'1'});
                this.$axios.post('storeAuth/saveStoreAuth',{
                    "roleId": this.id,
                    "storeId": this.$root.getStorage('storeId'),
                    "menuData":dataForm.menuData,
                    "storeAuthModel":{
                        "isDisplayPrein": dataForm.jurisdiction.indexOf('isDisplayPrein')>-1?"1":"0",
                        "isEditOther": dataForm.jurisdiction.indexOf('isEditOther')>-1?"1":"0",
                        "isSeeOther": dataForm.jurisdiction.indexOf('isSeeOther')>-1?"1":"0",
                        // "preBeginTime": dataForm.preBeginTime,
                        // "preEndTime": dataForm.preEndTime
                    }
                }).then(res=>{
                    this.$message.success('权限修改成功！');
                    this.resetForm();
                }).catch(err=>{
                    this.$message.error(err.msg)
                })
            },
            resetForm(){
                this.$refs.ruleForm.resetFields();
                this.$emit('update:visible',false);
                this.$emit('refreshList');
            },
        }
    }
</script>

<style scoped lang="scss">
.menulist{
    width: calc(100% - 34px);
    height: 200px;
    padding: 5px 15px;
   border: 1px solid #DCDFE6;
    border-radius: 4px;
    overflow-y: scroll;
}
</style>